import React, { useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown, Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { QRCodeCanvas } from "qrcode.react";
import { MdFileDownload } from "react-icons/md";
import { BsArrowRepeat } from "react-icons/bs";

const CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <span
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{ cursor: "pointer", fontSize: "18px" }}
    >
        <BsThreeDotsVertical />
    </span>
));
const OnlineTicketsSuper = () => {
    const [showModal, setShowModal] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);

    const handleView = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const handleInvoiceView = (row) => {
        setSelectedRow(row);
        setShowInvoiceModal(true);
    };

    const getBadgeClass = (status) => {
        switch (status) {
            case "Active":
                return "badge-opacity-success badge-rounded";
            case "Used":
                return "badge-opacity-warning badge-rounded";
            case "Expired":
                return "badge-opacity-danger badge-rounded";
            case "Pending":
                return "badge-opacity-info badge-rounded";
            case "Confirmed":
                return "badge-opacity-success badge-rounded";
            case "Refunded":
                return "badge-opacity-warning badge-rounded";
            case "Cancelled":
                return "badge-opacity-danger badge-rounded";
            default:
                return "badge-opacity-primary badge-rounded";
        }
    };

    const data = [
        {
            id: "B001",
            partnerType: "Organization",
            spotName: "Historical City Walk",
            visitor: "Alice Wonderland",
            phone: "555-0101",
            bookingDate: "Jul 15, 2024, 3:30 PM",
            visitDate: "Jul 16, 2024",
            qty: 2,
            ticketStatus: "Active",
            bookingStatus: "Confirmed",
            amount: "45.00 USD",
        },
        {
            id: "B002",
            partnerType: "Business",
            spotName: "Zip Line Experience",
            visitor: "Bob The Builder",
            phone: "555-0102",
            bookingDate: "Jul 20, 2024, 8:00 PM",
            visitDate: "Jul 20, 2024",
            qty: 1,
            ticketStatus: "Used",
            bookingStatus: "Pending",
            amount: "75.50 USD",
        },
        {
            id: "B004",
            partnerType: "Business",
            spotName: "Full Day Pass",
            visitor: "Diana Prince",
            phone: "555-0104",
            bookingDate: "Jul 18, 2024, 2:30 PM",
            visitDate: "Jul 19, 2024",
            qty: 3,
            ticketStatus: "Active",
            bookingStatus: "Confirmed",
            amount: "55.00 USD",
        },
        {
            id: "B005",
            partnerType: "Business",
            spotName: "Table Reservation",
            visitor: "Edward Scissorhands",
            phone: "555-0105",
            bookingDate: "Jul 13, 2024, 12:30 AM",
            visitDate: "Jul 12, 2024",
            qty: 1,
            ticketStatus: "Expired",
            bookingStatus: "Refunded",
            amount: "0.00 USD",
        },
        {
            id: "B007",
            partnerType: "Business",
            spotName: "Rock Climbing",
            visitor: "George Jetson",
            phone: "555-0107",
            bookingDate: "Jul 22, 2024, 3:00 PM",
            visitDate: "Jul 23, 2024",
            qty: 1,
            ticketStatus: "Expired",
            bookingStatus: "Cancelled",
            amount: "60.00 USD",
        },
    ];

    return <>
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="container mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h4 className="text-dark mb-1 d-flex align-items-center">
                                    Online Tickets Super
                                </h4>
                                <p className="text-muted mb-0">View and manage all counter ticket salse and related activities</p>
                            </div>
                            <div className="mt-2 mt-md-0">
                                <button className="btn btn-primary d-flex align-items-center">
                                    <MdFileDownload className="me-2" size={20} />
                                    Export Ticket Data
                                </button>
                            </div>
                        </div>


                        <div className="container p-0">
                            <div className="d-flex align-items-center flex-nowrap gap-2 mb-3 filter-box">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search ID, Customer, Service"
                                />
                              
                                <select className="form-select">
                                    <option>All Time</option>
                                </select>
                                <select className="form-select">
                                    <option>Ticket Status</option>
                                </select>
                                <select className="form-select">
                                    <option>All Statuses</option>
                                </select>
                                {/* <select className="form-select">
                                    <option>All Ticket Types</option>
                                    <option>Online</option>
                                    <option>Counter</option>
                                </select> */}
                                <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                                    <BsArrowRepeat size={16} />
                                    Clear Filters
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Booking ID</th>
                                            <th>Partner Type</th>
                                            <th>Spot Name</th>
                                            <th>Visitor Details</th>
                                            <th>Booking Date & Time</th>
                                            <th>Visit Date</th>
                                            <th>Qty</th>
                                            <th>Ticket Status</th>
                                            <th>Booking Status</th>
                                            <th>Amount</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row, idx) => (

                                            <tr key={idx}>

                                                <td>{row.id}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${row.partnerType === "Business"
                                                                ? "badge-opacity-business"
                                                                : "badge-opacity-organization"
                                                            }`}
                                                    >
                                                        {row.partnerType}
                                                    </span>

                                                </td>
                                                <td>{row.spotName}</td>
                                                <td>
                                                    {row.visitor}
                                                    <br />
                                                    <small className="text-muted">{row.phone}</small>
                                                </td>
                                                <td>{row.bookingDate}</td>
                                                <td>{row.visitDate}</td>
                                                <td>{row.qty}</td>
                                                <td>
                                                    <span className={getBadgeClass(row.ticketStatus)}>
                                                        {row.ticketStatus}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={getBadgeClass(row.bookingStatus)}>
                                                        {row.bookingStatus}
                                                    </span>
                                                </td>
                                                <td>{row.amount}</td>
                                                <td className="text-center">
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle as={CustomToggle} />
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => handleView(row)}>
                                                                View Details
                                                            </Dropdown.Item>

                                                            <Dropdown.Item onClick={() => handleInvoiceView(row)}>
                                                                View Invoice
                                                            </Dropdown.Item>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* invoice modal */}

                            <Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)} size="md" centered>
                                <Modal.Header closeButton>
                                    <Modal.Title className="w-100">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <div>
                                                <h5 className="fw-bold mb-0">Invoice -B001</h5>
                                                <small className="text-muted">Invoice for booking made on </small>
                                            </div>
                                        </div>
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body className="px-4">
                                    {selectedRow && (
                                        <div className="invoice-body">
                                            <div className="d-flex justify-content-between mt-2 mb-4">
                                                <div>
                                                    <strong>Billed To:</strong>
                                                    <p className="mb-0">{selectedRow.visitor}</p>
                                                </div>
                                                <div>
                                                    <strong>From:</strong>
                                                    <p className="mb-0">City Heritage Tours</p>
                                                    <p className="mb-0">Traverse Platform</p>
                                                </div>
                                            </div>

                                            <div className="border-top pt-3 mb-3">
                                                <strong>Booking Details:</strong>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>Service:</span>
                                                    <span>{selectedRow.spotName}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span>Date:</span>
                                                    <span>{selectedRow.bookingDate}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span>Status:</span>
                                                    <span>{selectedRow.bookingStatus}</span>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between border-top pt-3">
                                                <strong>Total Amount:</strong>
                                                <strong style={{ color: "#3b82f6" }}>{selectedRow.amount}</strong>
                                            </div>

                                            <p className="text-muted mt-4 mb-2" style={{ fontSize: "0.85rem" }}>
                                                This is a mock invoice for demonstration purposes.
                                                <br />
                                                Payment is processed through Traverse Platform.
                                            </p>
                                        </div>
                                    )}
                                </Modal.Body>

                                <Modal.Footer className="justify-content-end px-4">
                                    <Button variant="outline-secondary" className="me-2">
                                        <i className="bi bi-share me-1"></i> Share
                                    </Button>
                                    <Button variant="outline-secondary" className="me-2">
                                        <i className="bi bi-download me-1"></i> Download
                                    </Button>
                                    <Button variant="primary">
                                        <i className="bi bi-printer me-1"></i> Print
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal for View Details */}
                            <Modal show={showModal} onHide={() => setShowModal(false)}>

                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        <h5 className="fw-bold mb-0">Tickets Details: TKT001</h5>
                                        <small className="text-muted " >
                                            Complete information selected online ticket.
                                        </small>

                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ fontSize: "0.92rem" }}>


                                    {selectedRow && (
                                        <div className="row g-2">

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Ticket ID:</span>
                                                <span>TKT001</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Spot Name:</span>
                                                <span>Zip Line Experience</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Visitor Name:</span>
                                                <span>Bob The Builder</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Visitor Phone:</span>
                                                <span>555-0102</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Booking Date & Time:</span>
                                                <span>Jul 20, 2024, 8:00 PM</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Visit Date:</span>
                                                <span>Jul 20, 2024</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Quantity:</span>
                                                <span>2</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Type:</span>
                                                <span className="badge rounded-pill bg-light border text-dark">Online</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Ticket Status:</span>
                                                <span className="badge rounded-pill bg-success border text-white">Active</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Price/Ticket:</span>
                                                <span>₹ 75.50</span>
                                            </div>

                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Total Revenue:</span>
                                                <span>₹ 75.50</span>
                                            </div>
                                            <div className="mb-2 d-flex justify-content-between">
                                                <span>Payment Mode:</span>
                                                <span> Online</span>
                                            </div>
                                            <div className="text-center">
                                                <QRCodeCanvas
                                                    value="https://example.com/ticket/CNT246742"
                                                    size={100}
                                                    level="H"
                                                    includeMargin={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Modal.Body>


                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    </>;
};

export default OnlineTicketsSuper;

const Wrapper = styled.div`
.badge-opacity-success {
  background-color: rgba(25, 135, 84, 0.15);
  color: #198754;
}

.badge-opacity-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #856404;
}

.badge-opacity-danger {
  background-color: rgba(220, 53, 69, 0.15);
  color: #842029;
}

.badge-opacity-info {
  background-color: rgba(13, 202, 240, 0.15);
  color: #0dcaf0;
}

.badge-opacity-primary {
  background-color: rgba(13, 110, 253, 0.15);
  color: #0d6efd;
}

.badge-rounded {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  display: inline-block;
}

.bg-org {
  background-color: rgba(30, 144, 255, 0.15) !important;
  color: #1e90ff !important;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 0.75rem;
}

.table thead th {
  background-color: #f8f9fa;
}

.action-icon {
  cursor: pointer;
}

.filter-box input,
.filter-box select {
  width: 169px !important;
}
  .badge-opacity-business {
  background-color: rgba(0, 123, 255, 0.15); /* Soft Bootstrap Blue */
  color: #007bff;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 0.75rem;
}

.badge-opacity-organization {
  background-color: rgba(40, 167, 69, 0.15); /* Soft Bootstrap Green */
  color: #28a745;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 0.75rem;
}


`
